var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListBullets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5H23C23.5523 5 24 4.55228 24 4C24 3.44772 23.5523 3 23 3H8.5C7.94772 3 7.5 3.44772 7.5 4C7.5 4.55228 7.94772 5 8.5 5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 11H8.5C7.94772 11 7.5 11.4477 7.5 12C7.5 12.5523 7.94772 13 8.5 13H23C23.5523 13 24 12.5523 24 12C24 11.4477 23.5523 11 23 11Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19H8.5C7.94772 19 7.5 19.4477 7.5 20C7.5 20.5523 7.94772 21 8.5 21H23C23.5523 21 24 20.5523 24 20C24 19.4477 23.5523 19 23 19Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.99805C1 2.7219 1.22386 2.49805 1.5 2.49805H3.5C3.77614 2.49805 4 2.7219 4 2.99805V4.99805C4 5.27419 3.77614 5.49805 3.5 5.49805H1.5C1.22386 5.49805 1 5.27419 1 4.99805V2.99805Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 1.5H3.5C4.32843 1.5 5 2.17139 5 3V5C5 5.82861 4.32843 6.5 3.5 6.5H1.5C0.671574 6.5 0 5.82861 0 5V3C0 2.17139 0.671574 1.5 1.5 1.5ZM3.5 5.5C3.77614 5.5 4 5.27637 4 5V3C4 2.72363 3.77614 2.5 3.5 2.5H1.5C1.22386 2.5 1 2.72363 1 3V5C1 5.27637 1.22386 5.5 1.5 5.5H3.5Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.998C1 10.7219 1.22386 10.498 1.5 10.498H3.5C3.77614 10.498 4 10.7219 4 10.998V12.998C4 13.2742 3.77614 13.498 3.5 13.498H1.5C1.22386 13.498 1 13.2742 1 12.998V10.998Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 9.5H3.5C4.32843 9.5 5 10.1714 5 11V13C5 13.8286 4.32843 14.5 3.5 14.5H1.5C0.671574 14.5 0 13.8286 0 13V11C0 10.1714 0.671574 9.5 1.5 9.5ZM3.5 13.5C3.77614 13.5 4 13.2764 4 13V11C4 10.7236 3.77614 10.5 3.5 10.5H1.5C1.22386 10.5 1 10.7236 1 11V13C1 13.2764 1.22386 13.5 1.5 13.5H3.5Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.998C1 18.7219 1.22386 18.498 1.5 18.498H3.5C3.77614 18.498 4 18.7219 4 18.998V20.998C4 21.2742 3.77614 21.498 3.5 21.498H1.5C1.22386 21.498 1 21.2742 1 20.998V18.998Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 17.5H3.5C4.32843 17.5 5 18.1714 5 19V21C5 21.8286 4.32843 22.5 3.5 22.5H1.5C0.671574 22.5 0 21.8286 0 21V19C0 18.1714 0.671574 17.5 1.5 17.5ZM3.5 21.5C3.77614 21.5 4 21.2764 4 21V19C4 18.7236 3.77614 18.5 3.5 18.5H1.5C1.22386 18.5 1 18.7236 1 19V21C1 21.2764 1.22386 21.5 1.5 21.5H3.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListBullets);
export default __webpack_public_path__ + "static/media/listBullets.0a7f9c77.svg";
export { ForwardRef as ReactComponent };